export default {
  state: { user: null },
  namespaced: true,
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
  },
};
